import React from 'react';
import './btn4.css';

const Btn4 = (props) => {
  return (
    <button className="btn4" type="button">
      <span>{props.btnt}</span>

    
    </button>
  );
};

export default Btn4;